import { Component, HostListener, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-privacy-policy',
  standalone: false,
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent {


  blck:any;

  constructor(private route: ActivatedRoute,){
  this.blck = this.route.snapshot.paramMap.get("blk");

  }


}
